module.exports = __webpack_public_path__ + "img/return-parcel-at-distribution-center.dd276e6c.svg";